module.exports = __webpack_public_path__ + "img/international.1a21255d.jpg";